export class Usuario {

    id ?: number;
    nome: string;
    matricula ?: number;
    matricula_ergon ?: number;
    cpf: string;
    email: string;
    password?: string;
    is_active: boolean;
    senha_default?: string;


}



// WEBPACK FOOTER //
// ./src/app/models/Usuario.ts